import { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SometimesInlineFiltersCheckBox } from './Filters.styles';

import {
    updateFilter,
    billsIncludedSelector,
    petsAllowedSelector,
    shortLetsSelector
} from '@zoopla/redux-reducer-filters';

export const SelectLettingType: FC = () => {
    const reduxDispatch = useDispatch();

    const onBillsIncludedChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('billsIncluded', evt.currentTarget.checked));
    };

    const onPetsAllowedChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('petsAllowed', evt.currentTarget.checked));
    };

    const onShortLetsChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('rentalTerm', evt.currentTarget.checked));
    };

    const {
        label: billsIncludedLabel,
        selectedValue: billsIncludedSelectedValue
    } = useSelector(billsIncludedSelector);

    const { label: petsAllowedLabel, selectedValue: petsAllowedSelectedValue } =
        useSelector(petsAllowedSelector);

    const { label: shortLetsLabel, selectedValue: shortLetsSelectedValue } =
        useSelector(shortLetsSelector);

    return (
        <>
            <SometimesInlineFiltersCheckBox
                id={'shortLets'}
                data-testid={'shortLets'}
                onChange={onShortLetsChange}
                label={shortLetsLabel}
                checked={shortLetsSelectedValue}
            />
            <SometimesInlineFiltersCheckBox
                id={'billsIncluded'}
                data-testid={'billsIncluded'}
                onChange={onBillsIncludedChange}
                label={billsIncludedLabel}
                checked={billsIncludedSelectedValue}
            />
            <SometimesInlineFiltersCheckBox
                id={'petsAllowed'}
                data-testid={'petsAllowed'}
                onChange={onPetsAllowedChange}
                label={petsAllowedLabel}
                checked={petsAllowedSelectedValue}
            />
        </>
    );
};
